exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-player{display:flex;justify-content:center;padding:0 20px}.audio-player .audio-player__controls{margin-top:8px;margin-right:2.3%}.audio-player .audio-player__controls i.k-icon{font-size:36px;border-radius:4px;cursor:pointer}.audio-player .audio-player__controls i.k-icon:hover{background-color:#e7e9ee}.audio-player .audio-player__controls i.k-icon-caret-right,.audio-player .audio-player__controls i.k-icon-pause{color:#259af4}", ""]);

// exports
